.wrapper {
  flex: 1;
  min-width: 0;
}
